import appConfig from '../../config/appConfig';
import * as iccSsoDeeplinkTemplates from '../../consts/icc/iccSsoDeeplinkTemplates';
import * as loaderNames from '../../consts/loader/loaderNames';
import {hideLoader, showLoader} from '../../state/ducks/global';
import {showLoyaltyClubModalAction} from '../../state/ducks/modal';
import {
    makeSelectConsumerProductsMergedInfo,
    makeSelectIotDeviceMergedWithConsumerProduct,
} from '../../state/selectors/consumer';
import {makeSelectCurrentProductToChangeRegistrationStatus} from '../../state/selectors/productSettings';
import {dispatch, getState} from '../../state/store';
import cryptoService from '../cryptoService';
import iccMarketService from '../icc/iccMarketService';
import iccSsoService from '../icc/iccSsoService';
import marketTypeService from '../marketTypeService';
import routerService from '../routerService';

const checkLoyaltyClub = async () => {
    const isCanadaMarket = marketTypeService.isCanadaMarket();

    if (!isCanadaMarket) return;

    const configLoyaltyClub = appConfig.getLoyaltyClub();
    const isLoyaltyClubEmpty = !configLoyaltyClub?.length;

    if (isLoyaltyClubEmpty) return;

    const state = getState();
    const {device} = makeSelectIotDeviceMergedWithConsumerProduct()(state);
    const loyaltyClub = configLoyaltyClub.find((club) => club.type === device.type);

    if (!loyaltyClub) return;

    const {deviceSerialNumber} = makeSelectCurrentProductToChangeRegistrationStatus()(state);
    const encryptDeviceSerialNumber = cryptoService.encryptDeviceSerialNumber(deviceSerialNumber);
    const productInfo = await iccMarketService.getProductInfoList({
        serialNumbers: [encryptDeviceSerialNumber],
    });

    if (!productInfo) return;

    const deviceBrandFamily = productInfo[0]?.brandFamily;

    if (!deviceBrandFamily) return;

    const consumerProducts = makeSelectConsumerProductsMergedInfo()(state);
    const loyaltyClubBrandFamily = loyaltyClub.brandFamily;
    const isBrandFamilyConfigured = loyaltyClubBrandFamily?.length > 0;
    const consumerProductsSameType = consumerProducts.filter((product) => product.type === device.type);
    let isDevicesAlreadyRegistered = !!consumerProductsSameType.length;

    if (isBrandFamilyConfigured) {
        const isDeviceBrandFamilyInConfig = loyaltyClubBrandFamily.includes(deviceBrandFamily);

        if (!isDeviceBrandFamilyInConfig) return;

        isDevicesAlreadyRegistered = consumerProductsSameType.some((product) =>
            loyaltyClubBrandFamily.some((brand) => product.brandFamily === brand)
        );
    }

    if (isDevicesAlreadyRegistered) return;

    return dispatch(showLoyaltyClubModalAction());
};

const redirectToLoyaltyClubSsoLink = async (deeplinkTemplate, configLink) => {
    dispatch(showLoader(loaderNames.REDIRECT_LOADER_NAME));

    const ssoLink = await iccSsoService.getSsoLink(deeplinkTemplate);

    const redirectUrl = ssoLink ?? configLink;

    routerService.blankLinkOpen(redirectUrl);

    dispatch(hideLoader(loaderNames.REDIRECT_LOADER_NAME));
};

const redirectToLoyaltyClubSsoLinkDashboard = async () =>
    await redirectToLoyaltyClubSsoLink(
        iccSsoDeeplinkTemplates.ICC_SSO_LOYALTY_CLUB_DASHBOARD_DEEPLINK_TEMPLATE,
        appConfig.getLoyaltyClubDashboardUrlFormatted()
    );

const redirectToLoyaltyClubSsoLinkHomepage = async () =>
    await redirectToLoyaltyClubSsoLink(
        iccSsoDeeplinkTemplates.ICC_SSO_LOYALTY_CLUB_HOMEPAGE_DEEPLINK_TEMPLATE,
        appConfig.getLoyaltyClubHomepageUrlFormatted()
    );

export default {
    checkLoyaltyClub,
    redirectToLoyaltyClubSsoLinkDashboard,
    redirectToLoyaltyClubSsoLinkHomepage,
};
